export default __webpack_public_path__ + "static/media/hero-video.33b33e78.mp4";